module.exports = __webpack_public_path__ + "static/media/linkup.3b7fa538.png";